// import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import '../styles/Footer.css';

// const Footer = () => {
//   const socialLinks = [
//     { href: "https://www.facebook.com/share/19iP45u7GA/", icon: <FaFacebookF /> },
//     { href: "https://www.instagram.com/sepl_industry", icon: <FaInstagram /> },
//     { href: "https://twitter.com", icon: <FaTwitter /> },
//     { href: "https://linkedin.com", icon: <FaLinkedinIn /> },
//   ];

//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="bg-dark text-white pt-5 pb-3">
//       <div className="container">
//         <div className="row gy-4">

//           {/* Left Column: Contact Info */}
//           <div className="col-md-4 contact-section">
//             <h5 className="text-uppercase mb-3 contact-title">Get in Touch</h5>
//             {/* <p className="reach-out-text" style={{ fontWeight: 400 }}>
//               <strong>Reach out, we're always here!</strong>
//             </p> */}
//             <p className="contact-item">
//               <FaMapMarkerAlt className="contact-icon" />
//               A2/132 Site 5, Rudraksha Tower Kasna <br />
//               Greater Noida - 201310,<br />
//               Uttar Pradesh, India
//             </p>
//             <p className="contact-item">
//               <FaEnvelope className="contact-icon" />
//               <a href="mailto:connect@overair.in" className="contact-link">connect@alignedvertical.com</a>
//             </p>
//             <p className="contact-item">
//               <FaPhone className="contact-icon" />
//               <a href="tel:+919205936005" className="contact-link">+91 9205936005</a>
//             </p>
//           </div>

//           {/* Middle Column: Quick Links */}
//           <div className="col-md-4">
//             <h5 className="text-uppercase mb-3">Quick Links</h5>
//             <ul className="list-unstyled">
//               <li><Link to="/" className="footer-link">Home</Link></li>
//               <li><Link to="/about" className="footer-link">About</Link></li>
//               <li><Link to="/services/NetworkDesign" className="footer-link">Services</Link></li>
//               <li><Link to="/contact" className="footer-link">Contact</Link></li>
//               <li><Link to="/faq" className="footer-link">FAQ</Link></li> {/* ✅ Added FAQ */}
//             </ul>
//           </div>

//           {/* Right Column: Social Icons */}
//           <div className="col-md-4 text-md-end">
//             <h5 className="text-uppercase mb-3">Follow Us</h5>
//             <div className="d-flex justify-content-md-end gap-3 social-icons">
//               {socialLinks.map((link, index) => (
//                 <a
//                   key={index}
//                   href={link.href}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-white fs-5 icon-hover"
//                 >
//                   {link.icon}
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>

//         <hr className="border-secondary mt-4" />

//         <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
//           <p className="mb-1 small">© {currentYear} SEPL Industries. All rights reserved.</p>
//           <p className="mb-0 small">
//             Designed & Developed by{' '}
//             <a
//               href="https://overair.in"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="footer-link dev-link"
//             >
//               <strong>OverAir Pvt. Ltd</strong>
//             </a>
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const socialLinks = [
    { href: "https://www.facebook.com", icon: <FaFacebookF /> },
    { href: "https://www.instagram.com", icon: <FaInstagram /> },
    { href: "https://twitter.com", icon: <FaTwitter /> },
    { href: "https://linkedin.com", icon: <FaLinkedinIn /> },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <div className="container">
        <div className="row gy-4">

          {/* Left Column: Contact Info */}
          <div className="col-md-4 contact-section">
            <h5 className="text-uppercase mb-3 contact-title">Get in Touch</h5>
            <p className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              A2/132 Site 5, Rudraksha Tower Kasna <br />
              Greater Noida - 201310,<br />
              Uttar Pradesh, India
            </p>

            <p className="contact-item">
              <FaPhone className="contact-icon" />
              <a href="tel:+919205936005" className="contact-link">+91 9205936005</a>
            </p>

            {/* ✅ New IT Support & Enquiry Section */}
        
<h6 className="it-support-heading text-uppercase mt-4 mb-2">
   For IT Support & Enquiry
</h6>
<p className="contact-item">
  <FaEnvelope className="contact-icon" />
  <a href="mailto:Itsupport@alignedvertical.com" className="contact-link">
    itsupport@alignedvertical.com
  </a>
</p>

          </div>

          {/* Middle Column: Quick Links */}
          <div className="col-md-4">
            <h5 className="text-uppercase mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/services/NetworkDesign" className="footer-link">Services</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
              <li><Link to="/faq" className="footer-link">FAQ</Link></li>
            </ul>
          </div>

          {/* Right Column: Social Icons */}
          <div className="col-md-4 text-md-end">
            <h5 className="text-uppercase mb-3">Follow Us</h5>
            <div className="d-flex justify-content-md-end gap-3 social-icons">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white fs-5 icon-hover"
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        <hr className="border-secondary mt-4" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="mb-1 small">© {currentYear} Alignedvertical All rights reserved.</p>
          <p className="mb-0 small">
            Designed & Developed by{' '}
            <a
              href="https://overair.in"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link dev-link"
            >
              <strong>OverAir Pvt. Ltd</strong>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
